import { toast } from "react-toastify";

export const fileTypeVaidation = async (e, type) => {
  const file = e.target.files[0];
  const imageRegex = /image\//;
  const pdfRegex = /application\/pdf/;

  if (!file) {
    toast.error("No file selected.");
    return null;
  }

  switch (type) {
    case "image":
      if (!imageRegex.test(file.type)) {
        toast.error("Please only upload img, jpg, or png files.");
        return null;
      }
      return file; // Return the File object if validation passes

    case "pdf":
      if (!pdfRegex.test(file.type)) {
        toast.error("Please only upload PDF files.");
        return null;
      }
      return file; // Return the File object if validation passes

    default:
      toast.error("Unsupported file type.");
      return null;
  }
};
